// @ts-strict-ignore
/* eslint-disable @typescript-eslint/no-unused-vars */
import type { MutableRefObject } from 'react';
import { createContext } from 'react';
import type {
  CaretControlContext,
  CaretPositionGetterReturnValues,
  UserActionObject,
} from '../NodeEditorDrawer/types';
import type { MLASourceData } from './types';

type MLAContext = {
  ruleEditorFlatCaretIndices: string[];
  sourceData: MLASourceData;
  setSourceData: (_data: MLASourceData) => void;
  mlaEditorPanelBoxContainerRef: MutableRefObject<any>;
  handleCloseMLAEditor: () => void;
} & CaretControlContext;

export const MLAEditorContext = createContext<MLAContext>({
  ruleEditorFlatCaretIndices: [''],
  sourceData: {
    type: undefined,
    data: undefined,
    attributeTokenMap: undefined,
  },
  setSourceData: (_data: MLASourceData) => {},
  mlaEditorPanelBoxContainerRef: null,
  handleCloseMLAEditor: () => {},
  morphingCaretPosition: '',
  setMorphingCaretPosition: (_position: string) => {},
  getFlattenedCaretPositionIndex: ({
    itemPath,
    mode,
    insertion,
    type,
  }): string => undefined,
  pendingMorphingCaretPositionUpdateValue: undefined,
  setPendingMorphingCaretPositionUpdateValue: (_pendingPositionIdx: string) => {},
  activeInputValue: {
    value: '',
    path: '',
    initialValue: false,
  },
  setActiveInputValue: (_inputObject: {
    value: string;
    path: string;
    initialValue: boolean;
  }) => {},
  getPreviousCaretPosition: ({
    userActionObject,
  }: { userActionObject: UserActionObject }): CaretPositionGetterReturnValues => undefined,
  getNextCaretPosition: ({
    userActionObject,
  }: { userActionObject: UserActionObject }): CaretPositionGetterReturnValues => undefined,
  getNewPositionToJump: ({
    userActionObject,
  }: { userActionObject: UserActionObject }): CaretPositionGetterReturnValues => undefined,
  simpleEditorMode: false,
});
